import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
    id: '',
    title: '',
    routes: []
}

const siteGuideSlice = createSlice({
    name: 'site-guide',
    initialState: INITIAL_STATE,
    reducers: {
        saveSiteGuideVisitedRoute(state, action) {
            state.id = action.payload.id
            state.title = action.payload.title
            state.routes = action.payload.routes
        },
        resetSiteGuide: () => INITIAL_STATE

    }
})

export const { saveSiteGuideVisitedRoute, resetSiteGuide } = siteGuideSlice.actions
export default siteGuideSlice.reducer
